export const trackPixelEvent = (eventName, properties = {}) => {
  if (!window.fbq) return;
  try {
    window.fbq("track", eventName, properties);
  } catch (error) {
    console.error("Unable to track Pixel event:", { eventName, properties, error });
  }
};

export const trackCustomPixelEvent = (eventName, properties = {}) => {
  if (!window.fbq) return;
  try {
    window.fbq("trackCustom", eventName, properties);
  } catch (error) {
    console.error("Unable to track custom Pixel event:", { eventName, properties, error });
  }
};
